
/* injects from baggage-loader */
require('./style.scss');

import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const SpinnerCountdown = ({ duration, onChange }) => {
    const startTime = useRef(Date.now());
    const [seconds, setSeconds] = useState(duration);

    useEffect(() => {
        let timeout;
        
        if (seconds > 0) {
            timeout = setTimeout(() => {
                const difference = (Date.now() - startTime.current) / 1000;
                const newSeconds = duration - difference < 0 ? 0 : duration - difference;
                
                setSeconds(newSeconds);
                onChange?.(newSeconds);
            }, 1000);    
        }

        return () => clearTimeout(timeout);
    }, [seconds]);

    const time = useMemo(() => moment(seconds * 1000).format('mm:ss'), [seconds]);
 

    return <svg className="spinner-countdown" viewBox="0 0 33.83098862 33.83098862" width="75" height="75" xmlns="http://www.w3.org/2000/svg">
        <circle className="spinner-countdown__background" stroke="#454D4B" strokeWidth="2" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
        <circle className="spinner-countdown__circle" style={{ animationDuration: `${duration}s` }} stroke="#8AC241" strokeWidth="2" strokeDasharray="100,100" strokeLinecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
        <g className="spinner-countdown__info">
            <text className="spinner-countdown__percent" x="16.91549431" y="15.5" alignmentBaseline="central" fill="#ffffff" textAnchor="middle" fontSize="8">
                {time}
            </text>
        </g>
    </svg>;
};

SpinnerCountdown.propTypes = {
    duration: PropTypes.number.isRequired,
    onChange: PropTypes.func,
};

export default SpinnerCountdown;